import { DateTime } from 'luxon';
import { PriceTarget } from './price-target.interface';
import { CompanyFinancialItem } from './company-financial-item.interface';
import { FsData } from './fs-data.interface';
import { CompanyFinancialData } from './company-financial-data.interface';
import { CompanyPricing } from './company-pricing.model';


export class CompanyFinancial {
  priceTarget: PriceTarget;
  cash: CompanyFinancialItem;
  burn: CompanyFinancialItem;
  shares: CompanyFinancialItem;
  revenue: CompanyFinancialItem;
  useCalculatedFairValue: boolean;
  debt: CompanyFinancialItem;
  undrawnDebt: CompanyFinancialItem;
  drawableDebt: CompanyFinancialItem;
  asOfEndDate: CompanyFinancialItem;
  currencyCode: CompanyFinancialItem;
  oneYearOfCash: string;
  yearsOfCash: number;
  marketCap: CompanyFinancialItem;
  enterpriseValue: CompanyFinancialItem;
  probabilityOfSuccess: CompanyFinancialItem;
  wiwiiw: CompanyFinancialItem;
  ipoPrice: CompanyFinancialItem;
  ipoDate: string | DateTime;
  fsData: FsData;
  asOfEndDatePopoverInfo: string;
  priceTargetLongPopoverInfo: string;
  priceTargetFairPopoverInfo: string;
  priceTargetShortPopoverInfo: string;
  priceTargetDownsideFairPopoverInfo: string;
  priceTargetCalculatedFairPopoverInfo: string;
  cashPopoverInfo: string;
  burnPopoverInfo: string;
  marketCapPopoverInfo: string;
  enterpriseValuePopoverInfo: string;
  sharesPopoverInfo: string;
  revenuePopoverInfo: string;
  debtPopoverInfo: string;
  currencyCodePopoverInfo: string;
  undrawnDebtPopoverInfo: string;
  drawableDebtPopoverInfo: string;
  probabilityOfSuccessPopoverInfo: string;
  wiwiiwPopoverInfo: string;
  treasuryStockMethod: boolean;
  companyFinancial: CompanyFinancialData;
  openMarketPricing: CompanyPricing;
  preMarketPricing: CompanyPricing;
  postMarketPricing: CompanyPricing;
  fiftyTwoWeekHigh: CompanyPricing;
  fiftyTwoWeekLow: CompanyPricing;
  downsideFairValue: CompanyFinancialItem;
}
